import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';
import { useToast } from './Toast';

/** Reused across all 6 modules with Return for Redraft - "Returned by X - Reason: Y" plus a Resubmit button, matching the spec's exact required display. */
export function ReturnedBanner({
  returnComment, resubmit, queryKeysToInvalidate,
}: {
  returnComment: string | null;
  resubmit: () => Promise<unknown>;
  queryKeysToInvalidate: unknown[][];
}) {
  const { showSuccess, showError } = useToast();
  const queryClient = useQueryClient();

  const resubmitMutation = useMutation({
    mutationFn: () => resubmit(),
    onSuccess: () => { showSuccess('Resubmitted.'); queryKeysToInvalidate.forEach((k) => queryClient.invalidateQueries({ queryKey: k })); },
    onError: (err) => showError(err instanceof ApiError ? err.message : 'Failed to resubmit.'),
  });

  return (
    <div className="returned-banner">
      <strong>Returned for Redraft</strong>
      {returnComment && <p>Reason: {returnComment}</p>}
      <button onClick={() => resubmitMutation.mutate()} disabled={resubmitMutation.isPending}>
        {resubmitMutation.isPending ? 'Resubmitting…' : 'Resubmit'}
      </button>
    </div>
  );
}
